import { BaseFeature, FeatureType } from '@core/shared/feature';
export class NotificationsBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@common/notifications/feature","featureId":"common-notifications"},
      bundledItemModels: ["NotificationItem", "NotificationRecipientItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users'],
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'NotificationsFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'NotificationsFrontendAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'NotificationsBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'NotificationsBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {
          notifications: () => '/notifications'
        },
        admin: {
          notifications: () => '/notifications'
        }
      },
      virtualProperties: {
        'UserItem': [{
          name: 'receiveNotificationsByMail',
          type: 'boolean',
          canRead: ['self', 'admin'],
          canEdit: ['self', 'admin'],
          default: true
        }]
      }
    };
  }
}